<script setup>
import { watch, onMounted, ref } from 'vue'
import HeaderSearchResults from './HeaderSearchResults.vue'
import { useGlobalHeader } from '../composable/useGlobalHeader'
import { vOnClickOutside } from '@vueuse/components'
const { searchQuery, searchResults, searchCityInput } = useGlobalHeader()

const props = defineProps({
  lang: { type: String, default: 'ja' }
})
const emits = defineEmits(['update:searchResults', 'clickSearch'])
const clickSearch = () => {
  emits('clickSearch')
}

const isShow = ref(false)

const closeResults = () => {
  searchResults.value = []
}

watch(searchResults, (value) => {
  emits('update:searchResults', value)
})

onMounted(() => {
  isShow.value = window.innerWidth >= 768
})
</script>

<template>
  <div
    v-on-click-outside="closeResults"
    class="headerSearchArea"
  >
    <form
      class="form pc"
      @submit.prevent="searchCityInput(props.lang)"
    >
      <label
        for=""
        class="search"
      >
        <input
          id="search_pc"
          v-model="searchQuery"
          type="text"
          placeholder="都市名,郵便番号,市外局番など"
          class="input"
        >
        <button
          class="submit"
          aria-label="検索"
        >
          <img
            src="https://gvs.weathernews.jp/onebox/img/icon/icon_mushimegane.svg"
            width="30px"
            height="30px"
            class="icon"
            alt=""
          >
        </button>
      </label>
      <HeaderSearchResults
        :search-results="searchResults"
        :is-show="isShow"
        :is-pc="true"
      />
    </form>
    <button
      id="headerOverlayBtn__search"
      class="button sp"
      @click="clickSearch"
    >
      <span class="plainImage">
        <img
          src="https://gvs.weathernews.jp/onebox/img/icon/icon_mushimegane--blue.svg"
          width="20"
          height="20"
          alt=""
          loading="lazy"
        >
      </span>
      <span class="text">検索</span>
    </button>
    <button
      onclick="location.href='https://weathernews.jp/onebox/gps.html?fm=header'"
      class="button"
    >
      <span class="plainImage">
        <img
          src="https://gvs.weathernews.jp/onebox/img/icon/icon_search.svg"
          width="20"
          height="20"
          alt=""
          loading="lazy"
        >
      </span>
      <span class="text">現在地</span>
    </button>
  </div>
</template>

<style lang="scss" scoped>
.headerSearchArea {
  position: relative;
  display: flex;
  align-items: center;
  gap: 4px;
  padding-top: 4px;
  padding-bottom: 4px;
  &::before {
    position: absolute;
    top: 0;
    left: -14px;
    width: 5px;
    height: 100%;
    background: linear-gradient(270deg, rgba(#000, .25) 0%, rgba(#000, 0) 100%);
    z-index: 2;
    content: '';
  }
  .search {
    position: relative;
    .input {
      max-width: 200px;
      padding: 9px 40px 9px 18px;
      background-color: #fff;
      border: solid 1px #c0c0c0;;
      border-radius: 8px;
      font-size: 16px;
      line-height: 1.5em;
    }
    .submit {
      position: absolute;
      top: -5px;
      right: 9px;
    }
  }
  .button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 41px;
    height: 36px;
    padding: 2px;
    gap: 1px;
    border-radius: 8px;
    background: linear-gradient(180deg, #f0f3f6 0%, #e0e3e6 100%);
    box-shadow: 0 1px 2px 0 rgba(#000, .25);
    text-align: center;
    .text {
      color: #1f59ba;
      font-size: 10px;
      font-weight: bold;
      line-height: 10px;
    }
  }
  .form {
    position: relative;
  }
  .search_pc_block {
    position: absolute;
    z-index: 2;
  }
  .plainImage {
    line-height: 1;
  }
  @media screen and (min-width: 830px) {
    gap: 5px;
    &::before {
      display: none;
    }
    .search {
      .submit {
        transition: opacity .2s ease-in-out;
        cursor: pointer;
        &:hover {
          opacity: .6;
        }
      }
    }
    .button {
      width: 44px;
      height: 44px;
      gap: 3px;
      border: 1px solid #c0c0c0;
      box-shadow: none;
      background: #fff;
      transition: opacity .2s ease-in-out;
      cursor: pointer;
      &:hover {
        opacity: .6;
      }
      .text {
        font-size: 11px;
        line-height: 11px;
      }
    }
  }
}
</style>
